<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-card class=" px-3" style="background: #232323;" dark>
                    <span style="text-align: justify;" v-html="regulations.content" />
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import configService from '@/services/config'
    export default {
        data() {
            return {
                regulations: null
            }
        },
        created() {
            this.getRegulations()
        },
        methods: {
            getRegulations() {
                configService.getConfigField('regulation').then(resp => {
                    this.regulations = resp.data
                })
            }
        }
    }
</script>
